/**
 * Buckets an agent chat failure message for analytics. The message itself is
 * never sent: it can quote user text or provider internals. Only the bucket is.
 */
export function classifyChatError(message: string | null | undefined): string {
  const text = (message ?? "").toLowerCase();
  if (!text) return "unknown";
  if (/network|failed to fetch|econn|socket|offline/.test(text)) return "network";
  if (/timeout|timed out|deadline/.test(text)) return "timeout";
  if (/401|403|unauthori|forbidden|session/.test(text)) return "auth";
  if (/429|rate limit|too many/.test(text)) return "rate_limited";
  if (/limit|credit|allowance|entitlement|upgrade/.test(text)) return "limit";
  if (/5\d\d|internal|unavailable|overloaded/.test(text)) return "server";
  return "other";
}
